import React from "react";
import { Link } from "react-router-dom";
import "./Card.css";

function Card({ item }) {
  const {
    slug,
    title,
    year,
    category,
    director,
    thumbnailUrl,
    frames = [],
  } = item;

  const validFrames = Array.isArray(frames)
    ? frames.filter((src) => typeof src === "string" && src.trim().length > 0)
    : [];

  const hasTriptych = validFrames.length >= 3;
  const hasAnyFrame = validFrames.length >= 1;

  // If an image fails (e.g., a Drive URL typo), fall back to thumbnail
  const handleImgError = (e) => {
    if (thumbnailUrl && e?.currentTarget?.src !== thumbnailUrl) {
      e.currentTarget.src = thumbnailUrl;
    }
  };

  return (
    <article className="Card">
      <Link to={`/project/${slug}`} className="Card__link" aria-label={title}>
        <div
          className={`Card__mediaWrap ${
            hasTriptych ? "Card__mediaWrap--triptych" : ""
          }`}
        >
          {hasTriptych ? (
            <div className="Card__triptych">
              {validFrames.slice(0, 3).map((src, idx) => (
                <img
                  key={idx}
                  className={`Card__triptychImg Card__triptychImg--${idx + 1}`}
                  src={src}
                  alt={`${title} frame ${idx + 1}`}
                  loading="lazy"
                  onError={handleImgError}
                />
              ))}
              <div className="Card__overlay">
                <div className="Card__overlayText">
                  <div className="Card__overlayTitle">{title}</div>
                  {director && (
                    <div className="Card__overlaySub">
                      Directed by {director}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <img
              className="Card__img"
              src={hasAnyFrame ? validFrames[0] : thumbnailUrl}
              alt={title}
              loading="lazy"
              onError={handleImgError}
            />
          )}
        </div>

        <div className="Card__meta">
          <h2 className="Card__title">{title}</h2>
          <div className="Card__sub">
            {year && <span className="Card__year">{year}</span>}
            {year && category && <span className="Card__dot">•</span>}
            {category && <span className="Card__category">{category}</span>}
          </div>
        </div>
      </Link>
    </article>
  );
}

export default Card;
